import type { PayOverdueBalanceMutation } from '@ctct/state-server-layer';

import type { TranslationGetter } from '../../../types';
import { overduePaymentButtonEventBus } from '../OverduePaymentButtonEventBus';
import type { OverduePaymentButtonPageStore } from '../types';

export class OverduePaymentButtonService {
  constructor(
    private pageStore: OverduePaymentButtonPageStore,
    private payOverdueBalanceMutation: PayOverdueBalanceMutation,
    private t: TranslationGetter
  ) {
    overduePaymentButtonEventBus.emit('payOverdueBalanceLoading', payOverdueBalanceMutation.isPending, {
      source: 'asyncResponse',
    });

    if (payOverdueBalanceMutation.isError) {
      overduePaymentButtonEventBus.emit('payOverdueBalanceError', payOverdueBalanceMutation.error.message, {
        source: 'asyncResponse',
      });
    }

    if (payOverdueBalanceMutation.isSuccess) {
      overduePaymentButtonEventBus.emit('payOverdueBalanceSuccess', true, {
        source: 'asyncResponse',
      });
    }
  }

  public api() {
    return {
      disable: () => {
        this.pageStore.setState({ overduePaymentButtonDisabled: true });
      },
      enable: () => {
        this.pageStore.setState({ overduePaymentButtonDisabled: false });
      },
      getIsMobile: () => {
        return this.pageStore.getState().overduePaymentButtonOnMobile;
      },
      triggerButtonClick: () => {
        overduePaymentButtonEventBus.emit('payOverdueBalanceClicked', this.payOverdueBalanceMutation.mutateAsync, {
          source: 'api',
        });
      },
      getSuccessfulUpdateMessage: () => {
        return this.t('application-layer.overdue-payment.success-message');
      },
      getBillingAddressUpdateErrorMessage: () => {
        return this.t('application-layer.overdue-payment.billing-address-error');
      },
    };
  }

  public data() {
    return {
      getButtonLabel: () => {
        return this.t('application-layer.overdue-payment-button.button-label');
      },
      getTermsTransKey: () => 'application-layer.overdue-payment-button.terms',
      isLoading: () => this.payOverdueBalanceMutation.isPending,
    };
  }

  public handlers() {
    return {
      onPayButtonClick: () => {
        overduePaymentButtonEventBus.emit('payOverdueBalanceClicked', this.payOverdueBalanceMutation.mutateAsync, {
          source: 'user',
        });
      },
      onMobileUpdate: (isMobile: boolean) => {
        this.pageStore.setState({ overduePaymentButtonOnMobile: isMobile });
      },
    };
  }
}
